import React from "react";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";

interface ViewRejectionReasonProps {
  onClose: () => void;
  onSubmit: () => void;
  rejectionReason: string;
}

const ViewRejectionReason = ({
  onClose,
  onSubmit,
  rejectionReason,
}: ViewRejectionReasonProps) => {
  return (
    <div>
      <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
        <div className="tw-bg-white tw-rounded-2xl tw-w-96 tw-p-6">
          <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
            <div></div>
            <h2 className="tw-text-base font-weight-medium tw-text-[#1E293B]">
              Rejected Reason
            </h2>
            <button
              onClick={onClose}
              className="tw-text-gray-500 tw-hover:text-gray-700"
            >
              <img src={CloseIcon} alt="Close Icon" className="tw-w-3 tw-h-3" />
            </button>
          </div>

          <div>
            <p className="font-primary-color font-weight-base font-size-sm leading tw-mb-2">
              {rejectionReason}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRejectionReason;
